import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const JOB_FUNCTION_BY_UUID_RESOURCE = "job-function" as const;
export const JOB_FUNCTION_BY_UUID_API_PATH = `/v1/${JOB_FUNCTION_BY_UUID_RESOURCE}/{uuid}` as const;

export type JobFunctionByUuidParameters = paths[typeof JOB_FUNCTION_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type JobFunctionByUuidResponse =
  paths[typeof JOB_FUNCTION_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useJobFunctionByUuidQuery(uuid: string, options?: Options<JobFunctionByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<JobFunctionByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [JOB_FUNCTION_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<JobFunctionByUuidResponse>(
        `/v1/${JOB_FUNCTION_BY_UUID_RESOURCE}/${uuid}`,
        {
          params: requestParameters,
        },
      );

      return response.data;
    },
  });
}
